"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValuesT = exports.KeyValues = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class KeyValues {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsKeyValues(bb, obj) {
        return (obj || new KeyValues()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsKeyValues(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new KeyValues()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    keys(index, optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
    }
    keysLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    values(index, optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
    }
    valuesLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startKeyValues(builder) {
        builder.startObject(2);
    }
    static addKeys(builder, keysOffset) {
        builder.addFieldOffset(0, keysOffset, 0);
    }
    static createKeysVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startKeysVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addValues(builder, valuesOffset) {
        builder.addFieldOffset(1, valuesOffset, 0);
    }
    static createValuesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startValuesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endKeyValues(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createKeyValues(builder, keysOffset, valuesOffset) {
        KeyValues.startKeyValues(builder);
        KeyValues.addKeys(builder, keysOffset);
        KeyValues.addValues(builder, valuesOffset);
        return KeyValues.endKeyValues(builder);
    }
    unpack() {
        return new KeyValuesT(this.bb.createScalarList(this.keys.bind(this), this.keysLength()), this.bb.createScalarList(this.values.bind(this), this.valuesLength()));
    }
    unpackTo(_o) {
        _o.keys = this.bb.createScalarList(this.keys.bind(this), this.keysLength());
        _o.values = this.bb.createScalarList(this.values.bind(this), this.valuesLength());
    }
}
exports.KeyValues = KeyValues;
class KeyValuesT {
    constructor(keys = [], values = []) {
        this.keys = keys;
        this.values = values;
    }
    pack(builder) {
        const keys = KeyValues.createKeysVector(builder, builder.createObjectOffsetList(this.keys));
        const values = KeyValues.createValuesVector(builder, builder.createObjectOffsetList(this.values));
        return KeyValues.createKeyValues(builder, keys, values);
    }
}
exports.KeyValuesT = KeyValuesT;
